import { render, staticRenderFns } from "./newSupplier.vue?vue&type=template&id=611c00fd&scoped=true"
import script from "./newSupplier.vue?vue&type=script&lang=js"
export * from "./newSupplier.vue?vue&type=script&lang=js"
import style0 from "./newSupplier.vue?vue&type=style&index=0&id=611c00fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611c00fd",
  null
  
)

export default component.exports